export default __webpack_public_path__ + "static/media/img (1).c731bf8d.jpg";